import { SIGN_UP_TYPE } from "@/data/analytics";

export const TRACKING_TYPE = {
  GTAG: "gtag",
  REDDIT: "reddit",
  FACEBOOK: "facebook",
  TWITTER: "twitter",
  FIRTR_PERMOTER: "fpr",
  POSTHOG: "posthog",
  TIKTOK: "tiktok",
  CUSTOMERIO: "customerio",
} as const;

export type TTrackingType = (typeof TRACKING_TYPE)[keyof typeof TRACKING_TYPE];

export type TSignUpType = (typeof SIGN_UP_TYPE)[keyof typeof SIGN_UP_TYPE];
